import { switchClasses } from '@mui/material';

import type { Theme } from '@mui/material';

export const muiSwitchOverrides = {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => {
			return {
				[`.${switchClasses.root}`]: {
					alignContent: 'flex-start',
				},
				[`& .${switchClasses.switchBase}`]: {
					[`+ .${switchClasses.track}`]: {
						backgroundColor: theme.palette.tsGoColor.grayLight(),
						opacity: 1,
					},
				},
				[`& .${switchClasses.switchBase}.${switchClasses.checked}`]: {
					color: theme.palette.tsGoColor.greenDark,
					[` .${switchClasses.thumb}`]: {
						backgroundColor: theme.palette.tsGoColor.greenDark,
					},
					[`+ .${switchClasses.track}`]: {
						backgroundColor: theme.palette.tsGoColor.greenLight,
						opacity: 1,
					},
				},
				[`& .${switchClasses.switchBase}.${switchClasses.disabled}`]: {
					color: theme.palette.tsGoColor.greenLight,
					[` .${switchClasses.thumb}`]: {
						backgroundColor: theme.palette.tsGoColor.gray,
					},
					[`+ .${switchClasses.track}`]: {
						backgroundColor: theme.palette.tsGoColor.black,
						opacity: 0.12,
					},
				},
			};
		},
	},
};
